var exports = {
  "Nr": "DiscoveryGuildCard.module__card___cHhhbz",
  "L8": "DiscoveryGuildCard.module__cardButton___cHhhbz",
  "vK": "DiscoveryGuildCard.module__banner___cHhhbz",
  "_e": "DiscoveryGuildCard.module__bannerImage___cHhhbz",
  "Dw": "DiscoveryGuildCard.module__bannerScrim___cHhhbz",
  "Kk": "DiscoveryGuildCard.module__icon___cHhhbz",
  "rf": "DiscoveryGuildCard.module__body___cHhhbz",
  "$": "DiscoveryGuildCard.module__titleRow___cHhhbz",
  "fh": "DiscoveryGuildCard.module__nameText___cHhhbz",
  "h_": "DiscoveryGuildCard.module__description___cHhhbz",
  "qr": "DiscoveryGuildCard.module__footer___cHhhbz",
  "dJ": "DiscoveryGuildCard.module__stat___cHhhbz",
  "gW": "DiscoveryGuildCard.module__statDot___cHhhbz",
  "rR": "DiscoveryGuildCard.module__statDotOnline___cHhhbz" + " " + "DiscoveryGuildCard.module__statDot___cHhhbz",
  "rb": "DiscoveryGuildCard.module__statDotMembers___cHhhbz" + " " + "DiscoveryGuildCard.module__statDot___cHhhbz",
  "KA": "DiscoveryGuildCard.module__statText___cHhhbz",
};

module.exports = exports;
